import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getEquipmentTypeListAll, getRealEstatesShort, getTypeTechnicalRoomAvailableColumns } from './api';

export const path = '/ppr/type-technical-room/list';

const PageTypeTechnicalRooms: React.FC = (props) => {
  const TypeTechnicalRooms = Loadable.Map({
    loader: {
      page: () => import('./page'),
      equipmentTypes: getEquipmentTypeListAll,
      realEstates: getRealEstatesShort,
      columns: getTypeTechnicalRoomAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TypeTechnicalRooms {...props} />;
};

export default PageTypeTechnicalRooms;
